import React, { useEffect } from 'react'
import { Layout, Card, List, Typography, theme } from 'antd'
import styles from './ContentfulLayout.module.css'

const { Content, Sider } = Layout
const { Link } = Typography

type TocItem = {
  id: string
  text: string
  level: number
}

type Props = {
  toc: TocItem[]
  content: React.ReactNode
}

export const ContentfulLayout = ({ toc, content }: Props) => {
  const { token } = theme.useToken()
  const [selectedItem, setSelectedItem] = React.useState<string | null>(null)

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash
      if (hash) {
        const el = document.getElementById(hash.slice(1))
        if (el) {
          el.scrollIntoView({ block: 'start' })
        }
      }
      setSelectedItem(hash)
    }

    handleHashChange()

    window.addEventListener('hashchange', handleHashChange)

    return () => {
      window.removeEventListener('hashchange', handleHashChange)
    }
  }, [])

  return (
    <Layout className={styles.pageLayout}>
      <Content className={styles.scrollableContent}>
        <Card>{content}</Card>
      </Content>

      <Sider className={styles.tocSider} width="clamp(10vw, 20vw, 20vw)">
        <div className={styles.tocWrapper}>
          <nav aria-label="Table of contents">
            <List<TocItem>
              size="small"
              dataSource={toc}
              renderItem={({ id, text, level }) => (
                <List.Item className={styles.listItem}>
                  <Link
                    href={`#${id}`}
                    onClick={() => setSelectedItem(`#${id}`)}
                    style={{
                      marginLeft: (level - 2) * 16,
                      fontWeight: selectedItem === `#${id}` ? 'bold' : 'normal',
                      color: selectedItem === `#${id}` ? token.colorTextSecondary : 'inherit',
                    }}
                  >
                    {text}
                  </Link>
                </List.Item>
              )}
            />
          </nav>
        </div>
      </Sider>
    </Layout>
  )
}
